<template>
  <div class="searchPage page">
    <div class="container">
      <search-template />
    </div>
    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapState } from 'vuex';
import SearchTemplate from '~/components/SearchTemplate';

export default {
  name: 'SearchPage',
  components: {
    LazyHydrate,
    SearchTemplate,
    NewsletterHome: () => import('~/components/Newsletter/NewsletterHome'),
  },
  nuxtI18n: {
    paths: {
      pl: '/wyszukiwarka/strona/:number',
      en: '/search/page/:number',
    },
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  head() {
    const currentPage = this.$helper.countCurrentPage(
      this.pagination.limit,
      this.pagination.offset,
    );

    return {
      title: `Strona ${currentPage} - ofix.pl`,
      meta: [
        ...(Object.keys(this.$route.query).length || currentPage < 2
          ? [
              {
                name: 'robots',
                content: 'noindex, nofollow',
              },
            ]
          : []),
        ...[
          {
            hid: 'description',
            name: 'description',
            content: `Strona ${currentPage} - Szeroka oferta produktów w niskich cenach. Darmowa dostawa od 100PLN w 24h.`,
          },
        ],
      ],
      link: [
        ...this.$helper.prevNextUrl(
          this.$route.query,
          this.pagination.offset,
          this.pagination.limit,
          this.pagination.countTotal,
          'search',
          'search-page-number',
        ),
      ],
    };
  },
};
</script>

<style lang="scss">
.searchPage {
  $root: &;

  @include rwd('tablet') {
    overflow-x: hidden;
  }
}
</style>
